<template>
  <footer class="footer mt-5 p-4 text-center">
    <ul class="list-inline">
      <li class="list-inline-item mx-3">
        <LinkItem
          title="情報セキュリティ"
          href="https://www.softbank.jp/corp/aboutus/governance/security/"
          color="black"
        />
      </li>
      <li class="list-inline-item mx-3">
        <LinkItem
          title="個人情報の取り扱いについて"
          href="https://www.softbank.jp/corp/privacy/"
          color="black"
        />
      </li>
      <li class="list-inline-item mx-3">
        <LinkItem
          title="サイトポリシー"
          href="https://www.ymobile.jp/copyright/"
          color="black"
        />
      </li>
      <li class="list-inline-item mx-3">
        <LinkItem
          title="プライバシーセンター"
          href="https://www.softbank.jp/privacy/"
          color="black"
        />
      </li>
      <li class="list-inline-item mx-3">
        <LinkItem
          title="特定商取引法に基づく表示"
          href="https://www.ymobile.jp/store/to_beginner/tokusho/"
          color="black"
        />
      </li>
    </ul>
    <p class="m-0">
      <small>Copyright &copy; SoftBank Group All rights reserved.</small>
    </p>
  </footer>
</template>

<style scoped>
  .footer {
    background-color: lightgray;
    color: black;
  }
</style>
